import React from 'react';

import { useMounted } from '@hooks/useMounted';

import HomeHeader from '@components/common/HomeHeader';
import { ITab } from '@components/common/Tab';

import { useMe } from '@utils/hook';

const HomeHeaderContainer = ({
  tabs,
}: {
  tabs: {
    tabs: ITab<number>[];
    activeTab: number;
    onChange: (tab: number) => void;
    lastPeekTabViewDate: Date | undefined;
    setLastPeekTabViewDate: React.Dispatch<
      React.SetStateAction<Date | undefined>
    >;
  };
}) => {
  const { data: me } = useMe();

  const hasNotification = !!me?.hasNewNotification;
  const isMoutnted = useMounted();

  if (!isMoutnted) {
    return <></>;
  }

  return (
    <HomeHeader
      hasNewNotification={hasNotification}
      tabs={tabs}
      isHome={true}
    />
  );
};

export default HomeHeaderContainer;

export const PlayHeaderContainer = React.memo(function PlayHeaderContainer({
  tabs,
  lastPeekTabViewDate,
}: {
  lastPeekTabViewDate?: Date;
  tabs: {
    tabs: ITab<'home' | 'home_ground' | 'home_peek'>[];
    activeTab: 'home' | 'home_ground' | 'home_peek';
    onChange: (tab: 'home' | 'home_ground' | 'home_peek') => void;
    setLastPeekTabViewDate: React.Dispatch<
      React.SetStateAction<Date | undefined>
    >;
  };
}) {
  const { data: me } = useMe();
  const hasNotification = !!me?.hasNewNotification;
  const isMoutnted = useMounted();

  if (!isMoutnted) {
    return <></>;
  }

  return (
    <HomeHeader
      hasNewNotification={hasNotification}
      tabs={tabs}
      lastPeekTabViewDate={lastPeekTabViewDate}
    />
  );
});
